import {AccessDeniedError, type AuthorizationManager} from './types.js';
import {AsyncStorageSecurityContextHolder, type SecurityContext} from './security-context.js';
import type {AsyncLocalStorage} from 'node:async_hooks';
import type {ServerWebExchange} from '../../../types/web/server';

import getLogger from '../../logger.js';

const logger = getLogger('security.auth');

export default function authorizationFilter(opts: {
    storage: AsyncLocalStorage<{ securityContext?: Promise<SecurityContext> }>,
    manager: AuthorizationManager<ServerWebExchange>
}) {
    const {manager, storage} = opts;
    return async (exchange: ServerWebExchange, next: () => Promise<void>) => {
        const promise = AsyncStorageSecurityContextHolder.getContext(storage)
            .then(c => c?.authentication);
        try {
            await manager.verify(promise, exchange);
            if (logger.enabledFor('debug')) {
                logger.debug('authorization successful')
            }
        } catch (error) {
            if (error instanceof AccessDeniedError) {
                if (logger.enabledFor('debug')) {
                    logger.debug(`authorization failed: ${error.message}`);
                }
            }
            throw error;
        }
        await next();
    };
}
